import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ImagePicker } from '@ionic-native/image-picker';
import { Keyboard } from '@ionic-native/keyboard';
import { IonicStorageModule } from '@ionic/storage';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicSelectableModule } from 'ionic-selectable';
import { ElasticModule } from 'ng-elastic';
import { ComponentsModule } from '../components/components.module';
import { DirectivesModule } from '../directives/directives.module';
import { FeedPage } from '../pages/employee/feed/feed.component';
import { LunchroulettePage } from '../pages/employee/lunchroulette/lunchroulette';
import { QuizzListPage } from '../pages/employee/quizz-list/quizz-list';
import { AwaitingPage } from '../pages/employer/clubs/awaiting-validation/awaiting';
import { ClubMembersPage } from '../pages/employer/clubs/club-members/club-members';
import { MyApp } from './app.component';

import { TabsPage } from '../pages/employee/tabs/tabs';

import { ConnectionsPage } from '../pages/employee/connections/connections';
import { HomePage } from '../pages/employee/home/home';
import { JobsPage } from '../pages/employee/jobs/jobs';
import { MenuPage } from '../pages/employee/menu/menu';
import { MessagePage } from '../pages/employee/message/message';
import { NlbrPipe } from '../pages/employee/message/nlbr.pipe';
import { MessagingPage } from '../pages/employee/messaging/messaging';
import { NetworkPage } from '../pages/employee/network/network';
import { NewPostPage } from '../pages/employee/new-post/new-post';
import { NotificationsPage } from '../pages/employee/notifications/notifications';
import { PostPage } from '../pages/employee/post/post';
import { ProfilePage } from '../pages/employee/profile/profile';
import { SearchPage } from '../pages/employee/search/search';
import { SettingsPage } from '../pages/employee/settings/settings';
import { LoginPage } from '../pages/login/login';
import { SignupPage } from '../pages/signup/signup';
import { WelcomePage } from '../pages/welcome/welcome';
import { CreateClubSponsorshipPage } from './../pages/employee/create-club-sponsorship/create-club-sponsorship';
import { CreateClubStandalonePage } from './../pages/employee/create-club-standalone/create-club-standalone';

import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'ion-datepicker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { ClubsPage } from '../pages/employer/clubs/clubs';
import { DashboardPage } from '../pages/employer/dashboard/dashboard';
import { LunchrouletteEmployerPage } from '../pages/employer/lunchroulette/lunchroulette';
import { RhEmployerPage } from '../pages/employer/rh/rh';
import { SondageEmployerPage } from '../pages/employer/sondage/sondage-employer';
import { TeambuildingEmployerPage } from '../pages/employer/teambuilding/teambuilding';


import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { ClubPopoverComponent } from '../components/club-popover/club-popover';
import { ContentTypeInterceptor } from '../interceptors/content-type.interceptor';
import { TokenInterceptor } from '../interceptors/token.interceptor';
import { AuthProvider } from '../providers/auth/auth';
import { AvatarProvider } from '../providers/avatar/avatar';
import { ClubProvider } from '../providers/club/club';
import { CommentProvider } from '../providers/comment/comment';
import { CommonProvider } from '../providers/common';
import { CompanyProvider } from '../providers/company/company';
import { LikeProvider } from '../providers/like/like';
import { PostProvider } from '../providers/post/post';
import { UserProvider } from '../providers/user/user';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { StarRatingModule } from 'ionic3-star-rating';
import { ImageViewerModal } from '../components/image-viewer/image-viewer.component';
import { FeedClub } from '../pages/employee/feed-club/feed-club.component';
import { EditProfileComponent } from '../pages/employee/profile/edit-profile/edit-profile.component';
import { FeedFocusComponent } from '../pages/employee/profile/feed-focus/feed-focus.component';
import { NotificationProvider } from '../providers/notification/notification';


import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SignaturePadModule } from 'angular2-signaturepad';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { ClubEditFormComponent } from '../components/club-popover/club-edit-form/club-edit-form';
import { CompanyCreatePage } from '../pages/createcompany/createcompany';
import { CreateLunch } from "../pages/employee/lunchroulette/create-lunch/create-lunch";
import { CreateVisio } from "../pages/employee/lunchroulette/create-visio/create-visio";
import { MeetteamDetailsPage } from '../pages/employee/lunchroulette/meet-details/meet-details';
import { MenuProfile } from "../pages/employee/menu-profile/menu-profile";
import { AllClubs } from "../pages/employee/network/all-clubs/all-clubs";
import { ClubDetails } from "../pages/employee/network/club-details/club-details";
import { ClubMembersListPage } from '../pages/employee/network/club-member-list/club-member-list';
import { ImageEdit } from "../pages/employee/new-post/image-edit/image-edit";
import { PollPage } from '../pages/employee/poll/poll';
import { ProfileAbout } from "../pages/employee/profile/profile-about/profile-about";
import { ProfileClubs } from "../pages/employee/profile/profile-clubs/profile-clubs";
import { ProfilePosts } from "../pages/employee/profile/profile-posts/profile-posts";
import { RGPDPage } from '../pages/employee/rgpd/rgpd';
import { TabsPageRh } from '../pages/employee/tabsRh/tabsRh';
import { RhDashboardPage } from '../pages/employee/_rh/dashboard/rh-dashboard';
import { RhDrivePage } from '../pages/employee/_rh/drive/rh-drive';
import { RhAmazementPage } from '../pages/employee/_rh/rh-amazement/rh-amazement';
import { RhBarometerPage } from '../pages/employee/_rh/rh-barometer/rh-barometer';
import { RhCustomInterview } from '../pages/employee/_rh/rh-custominterview/rh-custominterview';
import { RhCustomInterviewSignature } from '../pages/employee/_rh/rh-custominterview/rh-custominterview-signature/rh-custominterview-signature';
import { RhCustomInterviewGoalsPage } from '../pages/employee/_rh/rh-custominterview/rh_customerinterview-goals/rh-custominterview-goals';
import { RhGoalsAssignList } from '../pages/employee/_rh/rh-goals/goals-assign-list/goals-assign-list';
import { RhGoalsCreateList } from '../pages/employee/_rh/rh-goals/goals-create-list/goals-create-list';
import { RhGoalsSignList } from '../pages/employee/_rh/rh-goals/goals-sign-list/goals-sign-list';
import { RhGoalsPage } from '../pages/employee/_rh/rh-goals/rh-goals';
import { RhInterviewPage } from '../pages/employee/_rh/rh-interview/rh-interview';
import { RhInterviewDisplayPage } from '../pages/employee/_rh/rh-interview/rh-interview-display/rh-interview-display';
import { RhInterviewGoalsPage } from '../pages/employee/_rh/rh-interview/rh-interview-goals/rh-interview-goals';
import { RhInterviewListPage } from '../pages/employee/_rh/rh-interview/rh-interview-list/rh-interview-list';
import { RhInterviewManagerPage } from '../pages/employee/_rh/rh-interview/rh-interview-manager/rh-interview-manager';
import { RhKnowledgePagePage } from '../pages/employee/_rh/rh-knowledge/knowledge-page/knowledge-page';
import { RhKnowledgePage } from '../pages/employee/_rh/rh-knowledge/rh-knowledge';
import { RhManagerSkillSearchPage } from '../pages/employee/_rh/rh-managerskillsearch/rh-managerskillsearch';
import { RhOffboardingPage } from '../pages/employee/_rh/rh-offboarding/rh-offboarding';
import { RhSkillSearchPage } from '../pages/employee/_rh/rh-skillsearch/rh-skillsearch';
import { RhSkillsRatingPage } from '../pages/employee/_rh/rh-skillsrating/rh-skillsrating';
import { RhTasksPage } from '../pages/employee/_rh/rh-tasks/rh-tasks';
import { RhRHCSPage } from '../pages/employee/_rh/rhcs/rh-rhcs';
import { GeneralEmployerPage } from '../pages/employer/general/general';
import { NewSondagePage } from '../pages/employer/sondage/new-sondage/new-sondage';
import { SondageResultsPage } from '../pages/employer/sondage/sondages-results/sondages-results';
import { TimeAgoPipe } from '../pipes/timeago.pipe';
import { DashboardProvider } from '../providers/dashboard/dashboard';
import { EmployeeRhProvider } from '../providers/employeerh/employeerh';
import { GoalRhProvider } from '../providers/goals/goals';
import { KnowledgeProvider } from '../providers/knowledge/knowledge';
import { MeetteamProvider } from '../providers/meetteam/meetteam';
import { MessagingProvider } from '../providers/messaging/messaging';
import { OnesignalProvider } from '../providers/onesignal/onesignal';
import { PollProvider } from '../providers/poll/poll';
import { RegisterProvider } from '../providers/register/register';
import { RgpdProvider } from '../providers/rgpd/rgpd';
import { TodoRhProvider } from '../providers/tasks/tasks';
import { TBRProvider } from '../providers/tbr/tbr';
import { WellBeingProvider } from '../providers/wellbeing/wellbeing';



registerLocaleData(localeFr, 'fr');
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    MyApp,
    TabsPage,
    TabsPageRh,
    WelcomePage,
    LoginPage,
    SignupPage,
    MenuPage,
    HomePage,
    FeedClub,
    PostPage,
    NewPostPage,
    SearchPage,
    NetworkPage,
    MessagingPage,
    LunchroulettePage,
    NotificationsPage,
    JobsPage,
    ConnectionsPage,
    CreateClubSponsorshipPage,
    CreateClubStandalonePage,
    QuizzListPage,
    MessagePage,
    NlbrPipe,
    SettingsPage,
    ProfilePage,
    DashboardPage,
    FeedPage,
    ClubsPage,
    ClubMembersPage,
    LunchrouletteEmployerPage,
    TeambuildingEmployerPage,
    AwaitingPage,
    RhEmployerPage,
    ImageViewerModal,
    ClubPopoverComponent,
    EditProfileComponent,
    FeedFocusComponent,
    TimeAgoPipe,
    PollPage,
    SondageEmployerPage,
    NewSondagePage,
    MeetteamDetailsPage,
    ClubEditFormComponent,
    SondageResultsPage,
    ClubMembersListPage,
    CompanyCreatePage,
    GeneralEmployerPage,
    RhDashboardPage,
    RhDrivePage,
    RhRHCSPage,
    RhAmazementPage,
    RhOffboardingPage,
    RhInterviewPage,
    RhInterviewManagerPage,
    RhInterviewListPage,
    RhInterviewDisplayPage,
    RhInterviewGoalsPage,
    RhSkillsRatingPage,
    RhCustomInterview,
    RhCustomInterviewSignature,
    RhSkillSearchPage,
    RhManagerSkillSearchPage,
    ImageEdit,
    CreateLunch,
    CreateVisio,
    MenuProfile,
    ProfileClubs,
    ProfileAbout,
    ProfilePosts,
    AllClubs,
    ClubDetails,
    RGPDPage,
    RhBarometerPage,
    RhGoalsPage,
    RhGoalsCreateList,
    RhGoalsAssignList,
    RhGoalsSignList,
    RhTasksPage,
    RhKnowledgePage,
    RhKnowledgePagePage,
    RhCustomInterviewGoalsPage
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    ComponentsModule,
    DirectivesModule,
    ElasticModule,
    AngularCropperjsModule,
    DatePickerModule,
    FormsModule,
    DropzoneModule,
    IonicStorageModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    IonicModule.forRoot(MyApp, {
      mode: 'ios',// TODO: to have same iOS look for all platforms
      backButtonText: ''
    }),
    ReactiveFormsModule,
    IonicSelectableModule,
    StarRatingModule,
    SignaturePadModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    TabsPage,
    TabsPageRh,
    WelcomePage,
    LoginPage,
    SignupPage,
    MenuPage,
    HomePage,
    FeedClub,
    PostPage,
    NewPostPage,
    SearchPage,
    NetworkPage,
    MessagingPage,
    QuizzListPage,
    NotificationsPage,
    JobsPage,
    ConnectionsPage,
    CreateClubSponsorshipPage,
    CreateClubStandalonePage,
    MessagePage,
    LunchroulettePage,
    SettingsPage,
    ProfilePage,
    DashboardPage,
    FeedPage,
    ClubsPage,
    ClubMembersPage,
    LunchrouletteEmployerPage,
    TeambuildingEmployerPage,
    AwaitingPage,
    RhEmployerPage,
    ImageViewerModal,
    ClubPopoverComponent,
    EditProfileComponent,
    FeedFocusComponent,
    PollPage,
    SondageEmployerPage,
    NewSondagePage,
    MeetteamDetailsPage,
    ClubEditFormComponent,
    SondageResultsPage,
    ClubMembersListPage,
    CompanyCreatePage,
    GeneralEmployerPage,
    RhDashboardPage,
    RhDrivePage,
    RhRHCSPage,
    RhAmazementPage,
    RhOffboardingPage,
    RhInterviewPage,
    RhInterviewManagerPage,
    RhInterviewListPage,
    RhInterviewDisplayPage,
    RhInterviewGoalsPage,
    RhSkillsRatingPage,
    RhCustomInterview,
    RhCustomInterviewSignature,
    RhSkillSearchPage,
    RhManagerSkillSearchPage,
    ImageEdit,
    CreateLunch,
    CreateVisio,
    MenuProfile,
    ProfileClubs,
    ProfileAbout,
    ProfilePosts,
    AllClubs,
    ClubDetails,
    RGPDPage,
    RhBarometerPage,
    RhGoalsPage,
    RhGoalsCreateList,
    RhGoalsAssignList,
    RhGoalsSignList,
    RhTasksPage,
    RhKnowledgePage,
    RhKnowledgePagePage,
    RhCustomInterviewGoalsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Keyboard,
    ImagePicker,
    CommonProvider,
    InAppBrowser,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ContentTypeInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'fr' },
    JwtHelperService,
    Storage,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    RegisterProvider,
    AuthProvider,
    CompanyProvider,
    UserProvider,
    PostProvider,
    CommentProvider,
    LikeProvider,
    AvatarProvider,
    ClubProvider,
    NotificationProvider,
    PollProvider,
    MeetteamProvider,
    TBRProvider,
    MessagingProvider,
    DashboardProvider,
    EmployeeRhProvider,
    OnesignalProvider,
    WellBeingProvider,
    RgpdProvider,
    GoalRhProvider,
    TodoRhProvider,
    KnowledgeProvider
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule {
}





// WEBPACK FOOTER //
// ./src/app/app.module.ts